export default function({ state, commit, dispatch }, query) {
    // If all events have been loaded, further queries are not necessary
    if (state.allSchedules)
        return

    commit('startLoadingSchedules')

    return dispatch('get', {
        url: '/provider/' + state.id + '/schedule',
        query
    }, {
        root: true
    })
    .then((response) => {
        commit('addProviderSchedules', response.schedule)

        if (response.content) {
            commit('content/cache', response.content, { root: true })
        }

        // TODO: cache all event content
        // TODO: cache all returned patients

        // If there is a pagination token, store the token
        if (response.next)
            commit('loadNextSchedules', {
                next: response.next,
                ...query
            })

        // Otherwise store that all patients have been loaded if this was a query for all patients
        else
            commit('loadedAllSchedules')

        commit('finishLoadingSchedules')
    })
    .catch((error) => {
        commit('finishLoadingSchedules')
        throw error
    })
}
